export const solutionData = [
   {
      title: "Finance",
      content: "Business Registration for new Microfinance Banks",
   },
   {
      title: "Finance",
      content:
         "Microfinance Banks financial evaluation, planning and auditing  ",
   },
   {
      title: "Finance",
      content:
         "Money lending registration with Lagos state ministry of Home affairs",
   },
   {
      title: "Finance",
      content: "Asset and Business Financing",
   },
   {
      title: "Finance",
      content:
         "Market Research for Microfinance Banks and Small & Medium scale Enterprises",
   },
   {
      title: "Finance",
      content:
         "Financial Restructuring of Microfinance Banks and Small & Medium scale Enterprises",
   },
];

export const solutionDataOne = [
   {
      title: "FinTech",
      content: "Agency Banking",
   },
   {
      title: "FinTech",
      content: "Payment Terminal Service Provider (PTSP)",
   },
   {
      title: "FinTech",
      content: "Payment Solutions Service Provider (PSSP",
   },
   {
      title: "FinTech",
      content: "Mobile Money Operator (MMO)",
   },
   {
      title: "FinTech",
      content: "Microfinance Bank Licence",
   },
   {
      title: "FinTech",
      content: "Commercial Bank Licence",
   },
   {
      title: "FinTech",
      content: "International Money Transfer Operators (IMTO)",
   },   {
      title: "FinTech",
      content: "Super Agent Licence",
   },
];

export const solutionDataTwo = [
   {
      title: "Technology",
      content: "Bespoke Mobile and Web application solution",
   },
   {
      title: "Technology",
      content: "Interswitch and Nibss integration",
   },
   {
      title: "Technology",
      content: "Providing PSSP policy documents and certification",
   },
   {
      title: "Technology",
      content: "Network infrastructure deployment (-Radio/V-sat) to MFBs & SME",
   },
   {
      title: "Technology",
      content: "Security Surveillance System",
   },
];
